import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useSelector } from "react-redux";

import useTheme from "hooks/useTheme";

import CloseIcon from "theme/icons/Close";
import ASAFlaggedIcon from "theme/icons/ASAFlagged";
import AddAssetIcon from "theme/icons/AddAsset";

const AssetOptInModal = ({ isOpen, setIsOpen, action }) => {
	const { appLanguage, themeColor } = useTheme();

	const sendingTransaction = useSelector((state) => state.SendingTransaction);

	return (
		<Transition appear show={isOpen} as={Fragment}>
			<Dialog as="div" className="relative z-10" onClose={() => {}}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className={`fixed inset-0 ${themeColor?.bg} bg-opacity-30`} />
				</Transition.Child>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4 text-center">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
								<div className="flex flex-col w-full items-center">
									{!sendingTransaction && (
										<div className="flex w-full items-center justify-between">
											<p className={`text-md ${themeColor?.text}`}></p>
											<CloseIcon
												className="w-4 cursor-pointer"
												fill={themeColor?.hex}
												onClick={() => setIsOpen(false)}
											/>
										</div>
									)}

									<div className="flex flex-col w-full items-center justify-center space-y-7">
										<ASAFlaggedIcon className="w-8" fill={themeColor?.hex} />
										<Dialog.Title
											as="h3"
											className={`flex flex-col items-center font-medium leading-6 ${themeColor?.text} space-y-1`}
										>
											<p className={`text-sm ${themeColor?.text}`}>
												{appLanguage?.doYouWantToAddThisAsset}
											</p>
										</Dialog.Title>
									</div>
								</div>

								<div className="w-full flex mt-4 space-x-3 justify-center">
									{sendingTransaction ? (
										<img className="animate-spin mx-auto h-5 w-auto" src="/media/logo.png" alt="img" />
									) : (
										<button
											type="button"
											className={`flex w-full items-center justify-center ${themeColor?.bg} px-3 py-2 rounded-lg space-x-3 hover:shadow-lg`}
											onClick={() => action()}
										>
											<AddAssetIcon className="w-4" fill="#FFFFFF" />
											<p className={`text-sm text-white`}>{appLanguage?.confirm}</p>
										</button>
									)}
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition>
	);
};

export default AssetOptInModal;
